export default __webpack_public_path__ + "static/media/cart-small.cb9369a6.svg";